import { styled } from '@mui/system'
import { TTheme } from '@/core/theme'

export const PdfExportWrapper = styled('span')<{ theme?: TTheme }>`
    display: flex;
    gap: 6px;
    align-items: center;
    margin-top: 4px;

    &.is-loading {
        cursor: not-allowed;
    }
    .export-spinner {
        display: inline-block;
        width: 12px;
        height: 12px;
        border: 2px solid ${({ theme }) => theme.colors.greys[300]};
        border-top-color: ${({ theme }) => theme.colors.primary[400]};
        border-radius: 50%;
        animation: spin 0.8s linear infinite;
    }

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
`
